<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VzgqCQ/tc-custom/9780253052209.jpg?1731883366102" alt="This image is the cover for the book Ku Klux Klan in the Heartland"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ku Klux Klan in the Heartland
      </h1>
      <p class="bookDescription body article font2">
        <p>"Who is an American?" asked the Ku Klux Klan. It is a question that echoes as loudly today as it did in the early twentieth century. But who really joined the Klan? Were they "hillbillies, the Great Unteachables" as one journalist put it? It would be comforting to think so, but how then did they become one of the most powerful political forces in our nation's history? </p><p>In <i>The Ku Klux Klan in the Heartland</i>, renowned historian James H. Madison details the creation and reign of the infamous organization. Through the prism of their operations in Indiana and the Midwest, Madison explores the Klan's roots in respectable white protestant society. Convinced that America was heading in the wrong direction because of undesirable "un-American" elements, Klan members did not see themselves as bigoted racist extremists but as good Christian patriots joining proudly together in a righteous moral crusade. </p><p><i>The Ku Klux Klan in the Heartland</i> offers a detailed history of this powerful organization and examines how, through its use of intimidation, religious belief, and the ballot box, the ideals of Klan in the 1920s have on-going implications for America today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James H. Madison
      </h2>
      
      <p class="authorDescription body article"><P>James H. Madison is author of<I> Hoosiers: A New History of Indiana</I>,<I> Slinging Doughnuts for the Boys: An American Woman in World War II</I>, and <I>A Lynching in the Heartland: Race and Memory in America</I>. An award-winning teacher, Madison is the Thomas and Kathryn Miller Professor of History Emeritus, Indiana University Bloomington. The Midwestern History Association recently honored him with the Frederick Jackson Turner Lifetime Achievement Award.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb104a94